import React from 'react';
import * as S from './styles';

type Props = {
  children: React.ReactChild;
  onRemove: Function;
};

const getCharCount = (children: React.ReactChild) => {
  if (typeof children === 'string') {
    return children.length;
  }

  return null;
};

export const Chip = (props: Props) => {
  return (
    //@ts-ignore
    <S.ChipWrapper onClick={props.onRemove} wrap={getCharCount(props.children)}>
      {props.children}
      <S.CloseBtn type="button" />
    </S.ChipWrapper>
  );
};

export default Chip;
